<template>
  <d-modal
    class="crm-new-popup"
    v-if="showModal"
    @close="closeModal"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header class="calendar-popup-header">
      <d-modal-title>
        <h3 class="page-title">
          Wybierz dostawcę
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-container
        fluid
        class="px-4">
        <!-- Page Header -->
        <div class="form-group">
          <label for="supplier_id">Dostawca:</label>
          <div :class="{ 'form-control': true, 'is-select': true }">
            <v-select
              class="ml-2 w-100"
              :options="suppliers"
              :reduce="supplier => supplier.id"
              v-model="supplier_id"
              placeholder="Wybierz dostawcę"
              :searchable="false"
              label="name">
              <template
                slot="option"
                slot-scope="option">
                <div class="d-center">
                  {{ option.name ? option.name : '' }}
                </div>
              </template>
              <template
                slot="selected-option"
                slot-scope="option">
                <div class="selected d-center">
                  {{ option.name ? option.name : '' }}
                </div>
              </template>
            </v-select>
          </div>
        </div>
        <div class="popup-box-buttons">
          <d-button
            style="width: 100%"
            :disabled="!supplier_id"
            theme="success"
            class="text-nowrap"
            @click.prevent="submitForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3 w-100"
            @click.prevent="closeModal">
            Anuluj
          </d-button>
        </div>
      </d-container>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FormUtils from '@/utils/FormUtils';

export default {
  name: 'order-supplier',
  data () {
    return {
      supplier_id: ''
    };
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    refresh: {
      type: Function,
      required: true
    },
    dataToSend: {
      type: [Object, Array],
      required: true
    },
    suppliers: {
      type: [Object, Array],
      required: true
    },
    isEdit: {
      type: [String, Number],
      required: true
    }
  },
  watch: {
    isEdit (value) {
      if (value) {
        this.supplier_id = value;
      }
    }
  },
  methods: {
    submitForm () {
      let formDataToSend = {
        supplier_id: this.supplier_id,
      };
      let endpointUrl = '/orders/update/' + this.dataToSend.id;

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano dostawcę',
        successText: 'Wybrany dostawca został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja dostawcy nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.refresh();
          this.closeModal();
        }
      });
    }
  }
};
</script>

<style lang="scss">
.modal-body {
  .popup-box-buttons {
    display: flex;
    margin-top: 1rem;
    border-top: 1px solid #FBFBFB;
    padding-top: 2rem;
    button {
      width: 100%;
    }
  }
  .popupForm .modal-dialog {
    margin-top: 5rem;
  }
}
</style>
